{
  "toast": {
    "aBTestStarted": "A/B test started",
    "draftCampaignCreated": "Draft campaign created",
    "campaignScheduled": "Campaign scheduled",
    "journeyCreated": "Journey created",
    "journeyFlowSaved": "Journey flow saved",
    "segmentSaved": "Segment saved",
    "templateSaved": "Template saved",
    "reportExported": "{{reportType}} exported",
    "draftCreated": "Draft created: {{name}}",
    "abWinner": "Winner: variant {{variant}}"
  },
  "errors": {
    "failedToLoadABTests": "Failed to load A/B tests",
    "failedToCreateABTest": "Failed to create A/B test",
    "failedToPickWinner": "Failed to pick winner",
    "enterACampaignName": "Enter a campaign name",
    "selectAnAudienceSegment": "Select an audience segment",
    "failedToLoadCampaigns": "Failed to load campaigns",
    "failedToLoadSegments": "Failed to load segments",
    "failedToLoadTemplates": "Failed to load templates",
    "failedToCreateCampaign": "Failed to create campaign",
    "actionFailed": "Action failed",
    "failedToLoadPerformance": "Failed to load performance",
    "attributionFailed": "Attribution failed",
    "failedToLoadJourneys": "Failed to load journeys",
    "failedToCreateJourney": "Failed to create journey",
    "failedToSaveJourneyFlow": "Failed to save journey flow",
    "failedToLoadLifecyclePresets": "Failed to load lifecycle presets",
    "exportFailed": "Export failed",
    "failedToCreateSegment": "Failed to create segment",
    "previewFailed": "Preview failed",
    "templateNameIsRequired": "Template name is required",
    "failedToCreateTemplate": "Failed to create template"
  },
  "pages": {
    "noCampaignSelected": "No campaign selected",
    "selectACampaignFromTheList": "Select a campaign from the list to view delivery and engagement metrics.",
    "noAttributionData": "No attribution data",
    "scheduleCampaign": "Schedule campaign",
    "campaigns": "Campaigns",
    "noCampaignsYet": "No campaigns yet",
    "createApproveScheduleAndLaunchMulti": "Create, approve, schedule, and launch multi-channel campaigns with tracked delivery.",
    "createADraftWithAnAudience": "Create a draft with an audience segment and template, then submit for approval.",
    "marketing": "Marketing",
    "engagement": "Engagement",
    "openRate": "Open rate",
    "conversions": "Conversions",
    "engagementFunnel": "Engagement funnel",
    "campaignPerformanceEngagementAndConversionsFor": "Campaign performance, engagement, and conversions for your marketing scope",
    "espWebhooks": "ESP webhooks",
    "sendgridMailgunAndSimilarProvidersPost": "SendGrid, Mailgun, and similar providers POST open/click events to update campaign metrics",
    "journeys": "Journeys",
    "noJourneys": "No journeys",
    "automateNurtureFlowsWithTriggersActions": "Automate nurture flows with triggers, actions, delays, and goals using a visual step builder.",
    "createAJourneyToAutomateFollow": "Create a journey to automate follow-ups after key events.",
    "lifecycle": "Lifecycle",
    "oneClickDraftsForWelcomeCart": "One-click drafts for welcome, cart recovery, win-back, upsell, and renewal programs.",
    "reports": "Reports",
    "exportCampaignAndJourneyDataAnd": "Export campaign and journey data, and inspect multi-touch attribution per campaign.",
    "audienceSegments": "Audience segments",
    "noSegmentsYet": "No segments yet",
    "dynamicSegmentsWithRuleBuilderAnd": "Dynamic segments with rule builder and live preview",
    "createYourFirstDynamicAudienceSegment": "Create your first dynamic audience segment.",
    "templates": "Templates",
    "noTemplates": "No templates",
    "reusableEmailContentWithVersioningVia": "Reusable email content with versioning via the shared template service.",
    "createATemplateToAttachTo": "Create a template to attach to email campaigns."
  },
  "labels": {
    "variantARef": "Variant A ref",
    "variantBRef": "Variant B ref",
    "sent": "Sent",
    "opens": "Opens",
    "clicks": "Clicks",
    "bounces": "Bounces",
    "unsubscribes": "Unsubscribes",
    "conversions": "Conversions",
    "openRate": "Open rate",
    "clickRate": "Click rate",
    "roi": "ROI",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "removeStep": "Remove step",
    "stepType": "Step type",
    "action": "Action",
    "waitAmount": "Wait amount",
    "unit": "Unit",
    "displayLabel": "Display label",
    "sendAt": "Send at",
    "matchMode": "Match mode",
    "field": "Field",
    "operator": "Operator",
    "value": "Value",
    "name": "Name",
    "channel": "Channel",
    "audience": "Audience",
    "template": "Template",
    "springPromo": "Spring promo",
    "selectSegment": "Select segment",
    "optional": "Optional",
    "trigger": "Trigger",
    "welcomeSeries": "Welcome series",
    "audienceOptional": "Audience (optional)",
    "useDefaultRules": "Use default rules",
    "campaign": "Campaign",
    "model": "Model",
    "selectCampaign": "Select campaign",
    "allModels": "All models",
    "segmentName": "Segment name",
    "templateName": "Template name",
    "subjectLine": "Subject line",
    "bodyHtmlOrPlainText": "Body (HTML or plain text)"
  },
  "formActions": {
    "createDraft": "Create draft"
  },
  "listActions": {
    "newCampaign": "New campaign"
  }
}
